<template>
  <div>
    <md-radio v-model="val" :value="true" class="md-primary" @change="onChange"
      >{{ $store.getters.langindex === 1 ? 'Yes' : 'Bəli' }}</md-radio
    >
    <md-radio v-model="val" :value="false" class="md-primary" @change="onChange"
      >{{ $store.getters.langindex === 1 ? 'No' :'Xeyr'}}</md-radio
    >
    <md-field maxlength="5" v-if="withcomment && val === false">
      <label
        >{{ langtext(commenttitle) }}
        <span style="color: red">
          {{ commentrequired ? "*" : "" }}
        </span></label
      >
      <md-textarea
        v-model="comment"
        @keydown.native="onChange"
        style="resize: none"
      />
    </md-field>
    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import AnswerRequiredField from "./AnswerRequiredField";
export default {
  name: "answer-yes-no",
  props: {
    withcomment: {
      type: Boolean,
      default: false,
    },
    commenttitle: String,
    commentrequired: Boolean,
    required: Boolean,
  },
  components: {
    AnswerRequiredField,
  },
  data() {
    return {
      val: null,
      comment: "",
      isvalid: true,
    };
  },
  methods: {
    value() {
      return {
        value: this.val == null ? null : !this.val ? 0 : 1,
        comment: this.comment,
      };
    },
    isNegative() {
      return this.val == null ? false : this.value().value === 0 ? true : false;
    },
    isValid() {
      return this.required
        ? this.val !== null
          ? this.value().value == 0 && this.commentrequired && !this.comment
            ? false
            : true
          : false
        : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange() {
      this.isvalid = true;
      this.$emit("changed", this.value());
    },
  },
  mounted() {
  },
};
</script>

<style>
</style>